/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export interface Courtfile {
  /** @nullable */
  courtFileNumber?: string;
  /** @minLength 1 */
  courtLocation: string;
}
